import { isFeatureFlagEnabled } from "@/services/featureFlagService";

export async function getALMFeatureFlagValue(): Promise<boolean> {
    try {
        return await isFeatureFlagEnabled("ALM");
    } catch (error) {
        console.error("Error checking ALM feature flag:", error);
        return false;
    }
}

export async function getModalDialogsFeatureFlagValue(): Promise<boolean> {
    try {
        return await isFeatureFlagEnabled("FLUX-392-UpdateModelDialogsStyling");
    } catch (error) {
        console.error("Error checking FLUX-392-UpdateModelDialogsStyling feature flag:", error);
        return false;
    }
}

export async function getTabbedbarFeatureFlagValue(): Promise<boolean> {
    try {
        return await isFeatureFlagEnabled("FLUX-435-IconsToolbarToTabbedBar");
    } catch (error) {
        console.error("Error checking FLUX-435-IconsToolbarToTabbedBar feature flag:", error);
        return false;
    }
}

export async function getRightHandPanelsFeatureFlagValue(): Promise<boolean> {
    try {
        return await isFeatureFlagEnabled("FLUX-488-RightHandPanels");
    } catch (error) {
        console.error("Error checking FLUX-488-RightHandPanels feature flag:", error);
        return false;
    }
}

export async function getLeftNavContextMenuFeatureFlagValue(): Promise<boolean> {
    try {
        return await isFeatureFlagEnabled("FLUX-537-Left-Nav-Context-Menu");
    } catch (error) {
        console.error("Error checking FLUX-537-Left-Nav-Context-Menu feature flag:", error);
        return false;
    }
}

export async function getInvestmentRegistryWebFeatureFlagValue(): Promise<boolean> {
    try {
        return await isFeatureFlagEnabled("CONS-765-InvestmentRegistryWeb");
    } catch (error) {
        console.error("Error checking CONS-765-InvestmentRegistryWeb feature flag:", error);
        return false;
    }
}